<script>

	import Page from '@/containers/Page/Page'

	import './style.scss'

	export default {
		name: 'notfound',
		components: {
			Page,
		}
	}

</script>

<template>
	<Page class='notfound' :center='true'>
		404
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/NotFound/NotFound.vue